export const thumbnailImageHTMLString = (type, dataThumbnailImage) => {
  return type === "video" && dataThumbnailImage.length
    ? ` <span style="color: #606;">data-options</span><span style="color: #660;">=</span>` +
        `<span style="color:#080;">"thumbnail: ${dataThumbnailImage}"</span>`
    : "";
};
